// imports
import React from 'react';
import { useSelector } from 'react-redux';
import EmptySidebar from './empty';
import { IMAGE } from '../../../assets';
import { LINKS } from '../../../constants';
import { BackpackItem } from '../../../common/types';
import PaperBG from '../../../atoms/background/paper';
import { selectConfig, selectUserBackpack } from '../../../repositories/store/slices';

// interfaces / types / consts
interface Props { item: BackpackItem | undefined }

// exports
export default function ItemDetailView(props: Props): JSX.Element {
  const { item } = props;
  // hooks configuration
  const { texts } = useSelector(selectConfig);
  const { fetchStatus } = useSelector(selectUserBackpack);
  const textKey = fetchStatus === 'loading' ? 'list_loading' : '';
  // render
  return (
    <div className="dv-container">
      <PaperBG fold />
      <div className="dv-content">
        {item ? (
          <>
            <div className="dv-title">
              <div className="heading">
                <img src={IMAGE.HERO_TITLE_MOTIF} alt="Left Motif" />
                <span>{item.name}</span>
                <img className="right-motif" src={IMAGE.HERO_TITLE_MOTIF} alt="Right Motif" />
              </div>
              <div className="type">{item.type}</div>
            </div>
            <div className="scrollable-section">
              <div className="dv-image-container item">
                <div className="dv-avatar">
                  <img className="frame" src={IMAGE.AVATAR_FRAME} alt="avatar_frame" />
                  <div className="avatar item">
                    <img
                      alt="Backpack Item"
                      src={`${LINKS.BACKPACK_BUCKET_URL}/${item.id}.png`}
                      onError={({ currentTarget }) => { currentTarget.src = IMAGE.ITEM_PLACEHOLDER; }}
                    />
                  </div>
                </div>
              </div>
              <div className="dv-details">
                <p>{item.description}</p>
              </div>
            </div>
          </>
        ) : (
          <EmptySidebar
            placeholderImg={IMAGE.ITEM_PLACEHOLDER}
            title={texts[textKey]?.title || 'Loading...'}
            body={texts[textKey]?.body || 'Loading item details...'}
          />
        )}

      </div>
    </div>
  );
}
